export const removeObjectFromArrayByKeyAndValue = (
  array,
  keyName,
  keyValue
) => {
  const newArray = array;
  const indexOnArray = newArray.findIndex((item) => item[keyName] === keyValue);
  if (indexOnArray !== -1) newArray.splice(indexOnArray, 1);
  return newArray;
};
